module.exports = __webpack_public_path__ + "img/chofu_news_off.3e946a2a.svg";